import { AdvancedImage } from "@cloudinary/react";
import { fill } from "@cloudinary/url-gen/actions/resize";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { ConfirmDialog } from "primereact/confirmdialog";
import { DataTable } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import { useEffect } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import Loading from "../../../../components/Loading/Loading";
import { useToastContext } from "../../../../contexts/ToastContext/ToastContext";
import { useToggle } from "../../../../hooks/useToggle";
import localeText from "../../../../locale";
import { cloudinaryInstance } from "../../../../utilities/Cloudinary/cloudinaryInstance";
import { formatPrice } from "../../../../utilities/formatPrice";
import ChatModal from "../Orders/components/ChatModal";
import useOrderDetails from "./hooks/useOrderDetails";
import { useState } from "react";
import ShippingDetails from "./ShippingDetails";

const formatAddress = (order) => {
  return `${order.address ? order.address + ", " : ""}${order.number ? order.number + ", " : ""}${
    order.district ? order.district + ", " : ""
  }${order.city ? order.city + ", " : ""}${order.state ? order.state + ", " : ""}${
    order.postalCode ? order.postalCode + ", " : ""
  }${order.country ? order.country : ""}`;
};

const formatStatus = (tracking_state) => {
  if (tracking_state === "BOZZA" || tracking_state === "CONSEGNATA") return tracking_state;
  else if (tracking_state === "RITIRO RICHIESTO") return "RITIRORICHIESTO";
  else if (tracking_state === "IN SPEDIZIONE") return "INSPEDIZIONE";
};

const OrderDetails = (props) => {
  const { showErrorToast, showSuccessToast } = useToastContext();
  const {
    isLoading: loading,
    loadingLabel,
    confirmReceivedVisible,
    links,
    currentOrder,
    parcelInfo,
    confirmSendVisible,
    currency,
    shippingCompany,
    trackingObject,
    setConfirmSendVisible,
    setConfirmReceivedVisible,
    setShippingCompany,
    setTrackingObject,
    downloadLabel,
    sendOrder,
    receiveOrder,
    isReadyToPickup,
    isLoadingReadyForPickup,
  } = useOrderDetails({
    admin: props?.admin ? props?.admin : false,
    sales: props.sales,
    onErrorReceiveOrder: (code) => showErrorToast({ code }),
    onErrorSendOrder: (code) => showErrorToast({ code }),
    onErrorFillOutAll: () => showErrorToast({ detail: "pleaseFillOutAll" }),
    onErrorDownloadProducts: (code) => showErrorToast({ code }),
    onErrorGetParcel: () => showErrorToast({ code: 500000 }),
    onSuccessSendOrder: () => showSuccessToast({ detail: "productSentSuccessfully" }),
    onSuccessReceiveOrder: () => showSuccessToast({ detail: "productReceivedSuccessfully" }),
    onSuccessOrderIsReadyToPickup: () => showSuccessToast({ detail: "productIsReadyToPickup" }),
  });
  const History = useHistory();
  const url = useLocation();
  const [params, setParams] = useState(new URLSearchParams(window?.location?.search));

  const {
    value: isVisibleChat,
    setAsTrue: setVisibleChat,
    setAsFalse: setNotVisibleChat,
  } = useToggle();

  const handleOpenChat = (e) => {
    e.stopPropagation();
    if (currentOrder?.status !== "PENDING") {
      const newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?chat=true";

      window.history.pushState({ path: newurl }, "", newurl);
      setVisibleChat();
    }
  };

  const handleCloseChat = () => {
    const newurl =
      window.location.protocol + "//" + window.location.host + window.location.pathname;

    window.history.pushState({ path: newurl }, "", newurl);
    setParams(new URLSearchParams(newurl));
    setNotVisibleChat();
  };

  const handleGoBack = () => {
    let urlToBack;
    if (props?.admin) {
      urlToBack = "/dashboard-listorders";
    } else {
      urlToBack = url?.pathname?.includes("sales") ? "/dashboard-sales" : "/dashboard-purchases";
    }
    History.push(urlToBack);
  };

  useEffect(() => {
    if (currentOrder?.status !== "PENDING" && params.get("chat") === "true") setVisibleChat();
  }, [currentOrder, params, setVisibleChat, setNotVisibleChat]);

  const anyProductIsPickup = currentOrder?.pickinaddress;

  const isSeller =
    currentOrder?.seller?.username === localStorage.getItem("__extraconomy_username");

  const isPhysicalProduct =
    !currentOrder?.itens[0]?.product?.service && !currentOrder?.itens[0]?.product?.downloadable;

  return (
    <>
      {props.sales && props.plan === "Promoter" ? (
        <div className="card border-1 border-300">
          <div className="text-center">
            <i className="pi pi-lock text-8xl text-400 my-4"></i>
            <h2 className="my-6">{localeText("planNotAllowed")}</h2>
          </div>
        </div>
      ) : (
        <div>
          {currentOrder && isVisibleChat && (
            <ChatModal
              isVisible={isVisibleChat}
              setNotVisibleChat={handleCloseChat}
              currentOrder={currentOrder}
            />
          )}

          <ConfirmDialog
            visible={confirmReceivedVisible}
            onHide={() => setConfirmReceivedVisible(false)}
            message={() => {
              return (
                <>
                  {loading ? (
                    <div className="text-center">
                      <i className="pi pi-spin pi-spinner text-8xl text-500 my-6"></i>
                    </div>
                  ) : (
                    <>
                      {currentOrder && !currentOrder?.itens[0]?.product?.downloadable ? (
                        <>
                          {localeText(
                            currentOrder?.pickinaddress
                              ? "youconfirmOrderWasSent"
                              : "receiveThisOrder"
                          )}
                        </>
                      ) : (
                        <>{localeText("receiveDownloadLinksConfirmation")}</>
                      )}
                    </>
                  )}
                </>
              );
            }}
            header={localeText("confirmYourAction")}
            icon="pi pi-exclamation-triangle"
            accept={() => receiveOrder(currentOrder.buyer.username, currentOrder.id)}
            reject={() => setConfirmReceivedVisible(false)}
            acceptLabel={localeText("confirm")}
            rejectLabel={localeText("cancel")}
          />

          <ConfirmDialog
            visible={confirmSendVisible}
            onHide={() => setConfirmSendVisible(false)}
            message={() => {
              return (
                <>
                  {loading ? (
                    <div className="text-center">
                      <i className="pi pi-spin pi-spinner text-8xl text-500 my-6"></i>
                    </div>
                  ) : (
                    <>
                      {currentOrder?.itens[0]?.product?.subCategory?.service ? (
                        <p>{localeText("confirmOrderWasSent2")}</p>
                      ) : (
                        <>
                          {localeText("confirmOrderWasSent")}
                          <ul className="list-none mx-0 mt-4 p-0">
                            <li>
                              <label htmlFor="shipping">{localeText("shippingCompany")}:</label>
                            </li>
                            <li>
                              <InputText
                                className="mt-2 w-full"
                                name="shipping"
                                value={shippingCompany}
                                disabled={parcelInfo?.courier ? true : false}
                                onChange={(e) => setShippingCompany(e.target.value)}
                              />
                            </li>
                            <li className="mt-2">
                              <label htmlFor="tracking">{localeText("trackingObject")}:</label>
                            </li>
                            <li>
                              <InputText
                                className="mt-2 w-full"
                                name="tracking"
                                value={trackingObject}
                                disabled={parcelInfo?.shipping_code ? true : false}
                                onChange={(e) => setTrackingObject(e.target.value)}
                              />
                            </li>
                          </ul>
                        </>
                      )}
                    </>
                  )}
                </>
              );
            }}
            header={localeText("sendOrder")}
            icon="pi pi-exclamation-triangle"
            accept={() => {
              sendOrder(
                localStorage.getItem("__extraconomy_username"),
                currentOrder.id,
                shippingCompany,
                trackingObject
              );
            }}
            reject={() => setConfirmSendVisible(false)}
            acceptLabel={localeText("confirm")}
            rejectLabel={localeText("cancel")}
          />

          {loading ? (
            <Loading />
          ) : (
            <>
              {currentOrder && (
                <div className="card border-1 border-300">
                  <h3 className="my-4">
                    {localeText("orderInfo")} {props.admin ? currentOrder?.id : ""}
                  </h3>
                  <hr />

                  <div className="w-full flex flex-row flex-wrap justify-content-between align-items-center mb-4 gap-2">
                    <Button
                      label={localeText("backToOrdersList")}
                      className="md:max-w-max w-full"
                      icon="pi pi-arrow-left"
                      onClick={handleGoBack}
                    />

                    {!props.admin && (
                      <Button
                        className="md:max-w-max w-full"
                        onClick={(e) => handleOpenChat(e)}
                        label={isSeller ? localeText("talkToBuyer") : localeText("talkToSeller")}
                      />
                    )}
                  </div>

                  <div className="grid">
                    <div className="lg:col-9 col-12">
                      {!props.admin ? (
                        <>
                          <DataTable
                            className="mt-4 mb-6"
                            value={currentOrder.itens}
                            paginator
                            responsiveLayout="scroll"
                            loading={loading}
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate={localeText("showingFirstToLast")}
                            rows={10}
                            rowsPerPageOptions={[10, 20, 50]}
                          >
                            <Column
                              header={localeText("image")}
                              body={(product) => {
                                return (
                                  <Link to={`/product?id=${product.product.id}`}>
                                    <AdvancedImage
                                      cldImg={
                                        product.productVariation && product.productVariation.imageid
                                          ? cloudinaryInstance
                                              .image(product.productVariation.imageid)
                                              .resize(fill().width(600).height(600))
                                              .format("webp")
                                          : cloudinaryInstance
                                              .image(product.product.imageid1)
                                              .resize(fill().width(600).height(600))
                                              .format("webp")
                                      }
                                      height={75}
                                      style={{ border: "1px solid #E0E0E0" }}
                                      className="border-round product-thumbnail"
                                    />
                                  </Link>
                                );
                              }}
                            />
                            <Column
                              header={props.sales ? localeText("byBuyer") : localeText("seller")}
                              body={() => {
                                const seller = currentOrder.seller;
                                const buyer = currentOrder.buyer;

                                return (
                                  <>
                                    {props.sales ? (
                                      <>
                                        {buyer.firstname} {buyer.surname} ({buyer.username})
                                      </>
                                    ) : (
                                      <>
                                        {seller.firstname} {seller.surname} ({seller.username})
                                      </>
                                    )}
                                  </>
                                );
                              }}
                            />
                            <Column field="product.title" header={localeText("title")} />
                            <Column
                              header={localeText("price")}
                              body={(product) => {
                                let currentCurrency;
                                currentCurrency = product.product.currency;

                                return (
                                  <span>
                                    {product.product.promotionalPriceUnique &&
                                    !product.productVariation ? (
                                      <p className="font-light">
                                        {currentCurrency}{" "}
                                        {formatPrice(product.product.promotionalPriceUnique)}
                                      </p>
                                    ) : (
                                      <p className="font-light">
                                        {currentCurrency} {formatPrice(product.priceUnitary)}
                                      </p>
                                    )}
                                  </span>
                                );
                              }}
                            />
                            <Column
                              header={
                                currentOrder?.itens[0]?.product?.downloadable
                                  ? localeText("download")
                                  : localeText("quantity")
                              }
                              body={(product) => {
                                return (
                                  <>
                                    {!currentOrder?.itens[0]?.product?.downloadable ? (
                                      <>{product.quantity}</>
                                    ) : (
                                      <>
                                        {currentOrder.status === "RECEIVED" && links.length > 0 ? (
                                          <a
                                            href={`${
                                              links.find((link) => link.id === product.product.id)
                                                .urldownload
                                            }`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            <Button icon="pi pi-download" />
                                          </a>
                                        ) : (
                                          <p className="font-bold">
                                            {localeText("pressTheReceiveDownloadLinks")}
                                          </p>
                                        )}
                                      </>
                                    )}
                                  </>
                                );
                              }}
                              style={{ width: "15%" }}
                            />
                            <Column
                              header={"Cashback"}
                              body={(product) => {
                                return (
                                  <p>
                                    {currency} {formatPrice(product?.cashback)}
                                  </p>
                                );
                              }}
                              style={{ width: "15%" }}
                            />
                          </DataTable>
                          {currentOrder.banggood_order && <ShippingDetails order={currentOrder} />}
                        </>
                      ) : (
                        <>
                          <DataTable
                            className="mt-4 mb-6"
                            value={currentOrder.itens}
                            paginator
                            responsiveLayout="scroll"
                            loading={loading}
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate={localeText("showingFirstToLast")}
                            rows={10}
                            rowsPerPageOptions={[10, 20, 50]}
                          >
                            <Column
                              header={localeText("image")}
                              body={(product) => {
                                return (
                                  <Link to={`/product?id=${product.product.id}`}>
                                    <AdvancedImage
                                      cldImg={
                                        product.productVariation && product.productVariation.imageid
                                          ? cloudinaryInstance
                                              .image(product.productVariation.imageid)
                                              .resize(fill().width(600).height(600))
                                              .format("webp")
                                          : cloudinaryInstance
                                              .image(product.product.imageid1)
                                              .resize(fill().width(600).height(600))
                                              .format("webp")
                                      }
                                      height={75}
                                      style={{ border: "1px solid #E0E0E0" }}
                                      className="border-round product-thumbnail"
                                    />
                                  </Link>
                                );
                              }}
                            />
                            <Column
                              header={localeText("byBuyer")}
                              body={() => <>{currentOrder.buyer.username}</>}
                            />
                            <Column
                              header={localeText("seller")}
                              body={() => <>{currentOrder.seller.username}</>}
                            />
                            <Column field="product.title" header={localeText("title")} />
                            <Column
                              header={localeText("price")}
                              body={(product) => {
                                let currentCurrency;
                                currentCurrency = product.product.currency;

                                return (
                                  <span>
                                    {product.product.promotionalPriceUnique &&
                                    !product.productVariation ? (
                                      <p className="font-light">
                                        {currentCurrency}{" "}
                                        {formatPrice(product.product.promotionalPriceUnique)}
                                      </p>
                                    ) : (
                                      <p className="font-light">
                                        {currentCurrency} {formatPrice(product.priceUnitary)}
                                      </p>
                                    )}
                                  </span>
                                );
                              }}
                            />
                            <Column
                              header={localeText("percentExtracoin")}
                              field="percentualExtraCoin"
                            />
                            <Column
                              header={
                                currentOrder.itens[0].product.downloadable
                                  ? localeText("download")
                                  : localeText("quantity")
                              }
                              body={(product) => {
                                return (
                                  <>
                                    {!currentOrder.itens[0].product.downloadable ? (
                                      <>{product.quantity}</>
                                    ) : (
                                      <>
                                        {currentOrder.status === "RECEIVED" && links.length > 0 ? (
                                          <a
                                            href={`${
                                              links.find((link) => link.id === product.product.id)
                                                .urldownload
                                            }`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            <Button
                                              className="p-button-info p-button-rounded"
                                              icon="pi pi-download"
                                            />
                                          </a>
                                        ) : (
                                          <p className="font-bold">
                                            {localeText("pressTheReceiveDownloadLinks")}
                                          </p>
                                        )}
                                      </>
                                    )}
                                  </>
                                );
                              }}
                              style={{ width: "30%" }}
                            />
                          </DataTable>
                          {currentOrder.banggood_order && <ShippingDetails order={currentOrder} />}
                        </>
                      )}
                    </div>

                    <div className="lg:col-3 col-12">
                      <div className="card border-1 border-300">
                        <p className="p-2 surface-300 m-0 p-0">
                          <b>{localeText("orderData")}:</b>
                        </p>
                        <hr className="mt-2 p-0"></hr>

                        <div className="grid">
                          <div className="col-6">{localeText("subtotal")}:</div>
                          <div className="col-6">
                            {currency} {formatPrice(currentOrder.amountOrder)}
                          </div>
                        </div>

                        <div className="grid">
                          <div className="col-6">{localeText("platformFee")}:</div>
                          <div className="col-6">
                            {currency} {formatPrice(currentOrder.amountToPlatform)}
                          </div>
                        </div>

                        <div className="grid">
                          <div className="col-6">{localeText("freight")}:</div>
                          <div className="col-6">
                            {currency} {formatPrice(currentOrder?.amountShipment ?? 0)}
                          </div>
                        </div>

                        <div className="grid">
                          <div className="col-6">{localeText("total")}:</div>
                          <div className="col-6">
                            {currency} {formatPrice(currentOrder.amountTotal)}
                          </div>
                        </div>

                        {currentOrder.status !== "PENDING" && (
                          <>
                            <p className="p-2 surface-300 mt-2 mb-0 p-0">
                              <b>{localeText("howWasPaid")}:</b>
                            </p>
                            <hr className="mt-2 p-0"></hr>

                            <div className="grid">
                              <div className="col-6">Extracredit:</div>
                              <div className="col-6">
                                {currency} {formatPrice(currentOrder.amountWalletExtracoin)}
                              </div>
                            </div>

                            <div className="grid">
                              <div className="col-6">{localeText("amountWallet")}:</div>
                              <div className="col-6">
                                {currency} {formatPrice(currentOrder.amountWallet)}
                              </div>
                            </div>

                            <div className="grid">
                              <div className="col-6">{localeText("amountCash")}:</div>
                              <div className="col-6">
                                {currency} {formatPrice(currentOrder.amountCash)}
                              </div>
                            </div>
                          </>
                        )}

                        {anyProductIsPickup &&
                          !currentOrder?.idsendcloudmethod &&
                          !currentOrder.status !== "PAID" && (
                            <>
                              <p className="p-2 surface-300 m-0 p-0">
                                <b>{localeText("pickUpAddress")}:</b>
                              </p>
                              <hr className="mt-2 p-0"></hr>

                              <div className="grid">
                                <div className="col-12">{formatAddress(currentOrder.seller)}</div>
                              </div>
                            </>
                          )}

                        {isPhysicalProduct && !anyProductIsPickup && (
                          <>
                            <p className="p-2 surface-300 m-0 p-0">
                              <b>{localeText("deliveryAddress")}:</b>
                            </p>
                            <hr className="mt-2 p-0"></hr>

                            <div className="grid">
                              <div className="col-12">{formatAddress(currentOrder.buyer)}</div>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>

                  {(currentOrder.status === "SENT" || currentOrder.status === "RECEIVED") &&
                    !currentOrder.itens[0].product.downloadable &&
                    !currentOrder?.pickinaddress && (
                      <div className="grid mb-4">
                        <div className="lg:col-9 col-0"></div>
                        <div className="lg:col-3 col-12">
                          <div className="card border-1 border-300">
                            <p className="p-2 surface-300 mt-2 mb-0 p-0">
                              <b>{localeText("shippingInfo")}:</b>
                            </p>
                            <hr className="mt-2 p-0"></hr>

                            <div className="grid">
                              <div className="col-6">
                                {localeText("shippingCompany")}: {currentOrder.shippingcompany}
                              </div>
                            </div>

                            <div className="grid">
                              <div className="col-6">
                                {localeText("trackingObject")}: {currentOrder.trackingobject}
                              </div>
                            </div>

                            <div className="grid">
                              <div className="col-6">
                                Status:{" "}
                                {localeText(currentOrder.status === "SENT" ? "sent" : "received")}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                  {!props.admin && (
                    <div className="mb-4">
                      {props.sales && currentOrder.status === "PAID" ? (
                        <>
                          {loading ? (
                            <div className="text-center">
                              <i className="text-6xl my-8 pi pi-spin pi-spinner text-600"></i>
                            </div>
                          ) : (
                            <>
                              {currentOrder?.pickinaddress && isPhysicalProduct && !parcelInfo && (
                                <Button
                                  label={localeText("readyForPickup")}
                                  onClick={isReadyToPickup}
                                  disabled={isLoadingReadyForPickup}
                                />
                              )}

                              {isPhysicalProduct && parcelInfo && (
                                <>
                                  <div className="flex align-items-center justify-content-center mt-4">
                                    <i className="pi pi-exclamation-triangle text-3xl mr-2"></i>
                                    <h3 className="m-0">{localeText("attention")}</h3>
                                  </div>
                                  <p className="text-center">
                                    {localeText("dowloadYourLabelAndPutInYourProduct")}
                                  </p>
                                  <div className="flex justify-content-center">
                                    <Button
                                      className="mx-auto mt-1"
                                      label={localeText("downloadLabel")}
                                      loading={loadingLabel}
                                      onClick={() => downloadLabel()}
                                    />
                                  </div>

                                  <h4>{localeText("pickupInfo")}</h4>
                                  <hr></hr>

                                  <div className="grid">
                                    <div className="lg:col-6 col-12">
                                      <label>
                                        <b>{localeText("status")}:</b>
                                      </label>
                                      <p>
                                        {parcelInfo?.tracking_state ? (
                                          <p>
                                            {localeText(formatStatus(parcelInfo.tracking_state))}
                                          </p>
                                        ) : (
                                          localeText("youDontHave")
                                        )}
                                      </p>
                                    </div>
                                    <div className="lg:col-6 col-12">
                                      <label>
                                        <b>{localeText("shippingMethod")}:</b>
                                      </label>
                                      <p>
                                        {parcelInfo?.courier
                                          ? parcelInfo?.courier
                                          : localeText("youDontHave")}
                                      </p>
                                    </div>
                                    <div className="lg:col-6 col-12">
                                      <label>
                                        <b>{localeText("trackingNumber")}:</b>
                                      </label>
                                      <p>
                                        {parcelInfo?.shipping_code
                                          ? parcelInfo?.shipping_code
                                          : localeText("youDontHave")}
                                      </p>
                                    </div>
                                  </div>
                                </>
                              )}
                              {isPhysicalProduct &&
                                !parcelInfo &&
                                (currentOrder.shippingOption === "PAID" ||
                                  currentOrder.shippingOption === "FREESENDCLOUD") && (
                                  <p>{localeText("waitLabel")}</p>
                                )}

                              {isPhysicalProduct &&
                                ((currentOrder.buyer.country !== "IT" &&
                                  currentOrder.seller.country !== "IT") ||
                                  currentOrder.shippingOption === "FREE") &&
                                currentOrder.banggood_order === false && (
                                  <Button
                                    label={localeText("changeStatusToSent")}
                                    className="my-4"
                                    onClick={() => setConfirmSendVisible(true)}
                                  />
                                )}
                              {currentOrder?.itens[0]?.product?.subCategory?.service &&
                                currentOrder.status === "PAID" &&
                                currentOrder.banggood_order === false && (
                                  <Button
                                    label={localeText("changeStatusToSent")}
                                    className="my-4"
                                    onClick={() => setConfirmSendVisible(true)}
                                  />
                                )}
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          {currentOrder.status === "SENT" && !props.sales ? (
                            <>
                              {!currentOrder.itens[0].product.downloadable ? (
                                <Button
                                  label={localeText(
                                    currentOrder?.pickinaddress
                                      ? "productWasPickedUp"
                                      : "receiveOrder"
                                  )}
                                  className="my-4"
                                  onClick={() => setConfirmReceivedVisible(true)}
                                />
                              ) : (
                                <Button
                                  label={localeText("receiveDownloadLinks")}
                                  className="my-4"
                                  onClick={() =>
                                    receiveOrder(currentOrder.buyer.username, currentOrder.id)
                                  }
                                />
                              )}
                            </>
                          ) : (
                            <>
                              {!props.sales &&
                                currentOrder.status === "PAID" &&
                                !currentOrder?.pickinaddress &&
                                isPhysicalProduct &&
                                !parcelInfo && <p>{localeText("productIsYetToBeShipped")}</p>}

                              {!props.sales &&
                                currentOrder.status === "PAID" &&
                                currentOrder?.pickinaddress &&
                                isPhysicalProduct &&
                                !parcelInfo && <p>{localeText("sellerIsPreparingYourOrder")}</p>}

                              {!props.sales &&
                                currentOrder.status === "SENT" &&
                                currentOrder?.pickinaddress &&
                                isPhysicalProduct &&
                                !parcelInfo && <p>{localeText("sellerIsPreparingYourOrder")}</p>}

                              {props.sales &&
                                currentOrder.status === "SENT" &&
                                currentOrder?.pickinaddress &&
                                isPhysicalProduct &&
                                !parcelInfo && <p>{localeText("waitingForBuyerWithdrawal")}</p>}

                              {isPhysicalProduct && parcelInfo && (
                                <>
                                  <h4>{localeText("pickupInfo")}</h4>
                                  <hr></hr>

                                  <div className="grid">
                                    <div className="lg:col-6 col-12">
                                      <label>
                                        <b>{localeText("status")}:</b>
                                      </label>
                                      <p>
                                        {parcelInfo?.tracking_state
                                          ? localeText(formatStatus(parcelInfo.tracking_state))
                                          : localeText("youDontHave")}
                                      </p>
                                    </div>
                                    <div className="lg:col-6 col-12">
                                      <label>
                                        <b>{localeText("shippingMethod")}:</b>
                                      </label>
                                      <p>
                                        {parcelInfo?.courier
                                          ? parcelInfo?.courier
                                          : localeText("youDontHave")}
                                      </p>
                                    </div>
                                    <div className="lg:col-6 col-12">
                                      <label>
                                        <b>{localeText("trackingNumber")}:</b>
                                      </label>
                                      <p>
                                        {parcelInfo?.shipping_code
                                          ? parcelInfo?.shipping_code
                                          : localeText("youDontHave")}
                                      </p>
                                    </div>
                                  </div>
                                </>
                              )}
                            </>
                          )}
                        </>
                      )}
                    </div>
                  )}
                </div>
              )}
            </>
          )}
        </div>
      )}
    </>
  );
};

export default OrderDetails;
